import { useState } from "react";
import { neon } from "@/integrations/neon";
import { getErrorMessage } from "@/utils/errors";

interface UseDeleteSubmissionOptions {
  toast: ReturnType<typeof import("@/hooks/use-toast").useToast>["toast"];
  onSuccess?: () => void;
}

export const useDeleteSubmission = ({ toast, onSuccess }: UseDeleteSubmissionOptions) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteSubmission = async (submissionId: string) => {
    setIsDeleting(true);
    try {
      await neon.api.reviews.deleteSubmission(submissionId);

      toast({
        title: "Submission deleted",
        description: "The feedback submission has been removed successfully.",
      });

      if (onSuccess) {
        onSuccess();
      }
    } catch (err: unknown) {
      toast({
        title: "Delete failed",
        description: getErrorMessage(err, "Unable to delete submission"),
        variant: "destructive",
      });
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    deleteSubmission,
    isDeleting,
  };
};
